export const CLOSE_WINDOW = 'app/SaveProgressionModal/CLOSE_WINDOW';
export const OPEN_WINDOW = 'app/SaveProgressionModal/OPEN_WINDOW';
export const SAVE_EMAIL = 'app/SaveProgressionModal/SAVE_EMAIL_PROGRESSION';
export const SAVE_EMAIL_SUCCESS = 'app/SaveProgressionModal/SAVE_EMAIL_PROGRESSION_SUCCESS';
export const LOADING = 'app/SaveProgressionModal/LOADING';
export const SAVE_PROGRESS = 'SaveProgressionModal';
